// @ts-check
import { initSchema } from '@aws-amplify/datastore';
import { schema } from './schema';

const Chain = {
  "POLYGON": "POLYGON",
  "ETHEREUM": "ETHEREUM"
};

const { NFTSINFLUENCERS, NFTSNFTSINFLUENCERS, NFTS, USER, NFTSOLDINF } = initSchema(schema);

export {
  NFTSINFLUENCERS,
  NFTSNFTSINFLUENCERS,
  NFTS,
  USER,
  Chain,
  NFTSOLDINF
};